module.exports = __webpack_public_path__ + "static/img/blue_animate3.601a1c06.png";